import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

interface Props {
  plan: string | undefined;
}

export function StartTrialBanner({ plan }: Props) {
  if (plan && plan !== "free") return null;

  return (
    <Link
      to="/pricing"
      className="mb-4 block overflow-hidden rounded-2xl border border-brand-200/70 bg-gradient-to-r from-brand-50 via-white to-brand-50/40 p-4 no-underline shadow-xs transition-all hover:-translate-y-0.5 hover:shadow-md"
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-brand-gradient text-white shadow-sm">
            <Sparkles className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-ink-900">
              Start your 7-day free trial
            </p>
            <p className="text-xs text-ink-600">
              Unlock generations, voice training, scheduling, and analytics.
              Cancel any time in 7 days — no charge.
            </p>
          </div>
        </div>
        <span className="inline-flex items-center gap-1 rounded-full bg-brand-gradient px-3 py-1.5 text-xs font-semibold text-white shadow-sm">
          See plans
          <ArrowRight className="h-3.5 w-3.5" />
        </span>
      </div>
    </Link>
  );
}
